document.addEventListener('DOMContentLoaded', function() {

  // Rental-period line for a trip length: the exact duration first, else
  // the longest period at or below the trip, else the shortest one offered
  function pickPeriod(wrapper, days) {
    const exact = wrapper.querySelector('.rental-' + days);
    if (exact) return exact;
    let best = null, bestN = 0, shortest = null, shortestN = Infinity;
    wrapper.querySelectorAll('.price-hidden').forEach(el => {
      const m = el.className.match(/rental-(\d+)/);
      if (!m) return;
      const n = Number(m[1]);
      if (n <= days && n > bestN) { bestN = n; best = el; }
      if (n < shortestN) { shortestN = n; shortest = el; }
    });
    return best || shortest;
  }

  // Expose updatePriceDisplay globally so it can be called from date selectors
  window.updateProductCardPrices = function() {
    let savedData = null;
    try { savedData = JSON.parse(sessionStorage.getItem('dates')); } catch (e) { savedData = null; }
    const days = savedData ? Number(savedData.days) : 0;

    document.querySelectorAll('.price-hidden-wrapper').forEach(wrapper => {
      wrapper.querySelectorAll('.price-hidden.active').forEach(price => {
        price.classList.remove('active');
      });
      const active = days > 0 ? pickPeriod(wrapper, days) : null;
      // has-active must track the match: left behind with no .active line it
      // hides the 5-day fallback as well and the card shows no price at all
      wrapper.classList.toggle('has-active', Boolean(active));
      if (active) active.classList.add('active');
    });
  };

  // Local reference for internal use
  const updatePriceDisplay = window.updateProductCardPrices;

  // Initial update
  updatePriceDisplay();

  // Listen for storage changes (other tabs only - the storage event never
  // fires in the tab that wrote the value)
  window.addEventListener('storage', (e) => {
    if (e.key === 'dates') {
      updatePriceDisplay();
    }
  });

  // The trip tool mirrors its dates into sessionStorage and then fires this
  // in the same tab - the one path a same-tab date change reaches us by
  document.addEventListener('trip:change', updatePriceDisplay);

  // Create a mutation observer for price updates
  function createObserver(target) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' || 
            mutation.addedNodes.length > 0 || 
            mutation.target.classList.contains('product-recommendations')) {
          updatePriceDisplay();
        }
      });
    });

    if (target) {
      observer.observe(target, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
    }
    
    return observer;
  }

  // Observe the main product grid
  const productGrid = document.querySelector('#product-grid');
  if (productGrid) {
    createObserver(productGrid);
  }

  // Listen for collection filtering events
  document.addEventListener('click', function(e) {
    if (e.target.closest('.facets__form') || e.target.closest('.mobile-facets')) {
      setTimeout(updatePriceDisplay, 500); // Update prices after filter changes
    }
  });

  // Handle form submissions for filtering
  const filterForms = document.querySelectorAll('form[id^="FacetFiltersForm"]');
  filterForms.forEach(form => {
    form.addEventListener('submit', function() {
      setTimeout(updatePriceDisplay, 500);
    });
  });

  // Monitor price wrapper visibility changes
  const priceObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
        updatePriceDisplay();
      }
    });
  });

  document.querySelectorAll('.price-hidden-wrapper').forEach(wrapper => {
    priceObserver.observe(wrapper, {
      attributes: true,
      attributeFilter: ['style']
    });
  });

  // Listen for Shopify section updates
  document.addEventListener('shopify:section:load', updatePriceDisplay);

  // Watch for the recommendations section
  const recommendationsObserver = new MutationObserver((mutations, observer) => {
    const recommendationsSection = document.querySelector('product-recommendations');
    if (recommendationsSection) {
      createObserver(recommendationsSection);
      
      const slider = recommendationsSection.querySelector('.slider');
      if (slider) {
        createObserver(slider);
      }
      
      updatePriceDisplay();
      observer.disconnect();
    }
  });

  recommendationsObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Handle infinite scroll if present
  const collectionContainer = document.querySelector('.collection');
  if (collectionContainer) {
    createObserver(collectionContainer);
  }

  // Watch for facet updates
  const facetsContainer = document.querySelector('.facets-container');
  if (facetsContainer) {
    createObserver(facetsContainer);
  }
});